module.exports = __webpack_public_path__ + "static/images/challenge.85bebf1f63bf0eae7fb535a83ae47637.png";